import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = [];
  static selectedBookables = [];
  static isBulkEditing = false;

  connect() {

  }

  selectBookable(e) {
    const bookableId = e.currentTarget.dataset.bookableId
    const bookableInput = document.querySelector("input[name='bookable_amenities[bookable_id]']")
    bookableInput.value = bookableId

    const amenitySelectorPartial = document.querySelector(".bookable-amenity-selector")
    const placeholderPartial = document.querySelector(".selector-placeholder")

    amenitySelectorPartial.classList.remove("hidden")
    placeholderPartial.classList.add("hidden")
    e.currentTarget.classList.add("selected")

    this.element.querySelectorAll(".item.selected").forEach((el) => {
      if (el !== e.currentTarget) el.classList.remove("selected")
    })
  }

  submitForm(e) {
    e.preventDefault()
    //form in the active tab
    const form = document.querySelector(".tab-pane.active").querySelector("form")
    form.requestSubmit();
  }
}


